import React, { useEffect, useState } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import _ from 'lodash';
import { faBookmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { XCircleIcon } from "@heroicons/react/outline";
import TagsEditor from "./TagsEditor";
import imgCamelLogo from '../../assets/images/main-logo-white.png';

import "./UpdateItemTagsForm.scss";

const UpdateItemTagsForm = props => {
  const [selectedTags, setSelectedTags] = useState({});

  useEffect(() => {
    const tags = _.get(props, 'itemData.meta.contentTags', {});
    setSelectedTags(tags);
  }, [])

  const onSubmit = (e) => {
    e.preventDefault();

    const itemDetails = _.get(props, 'itemData', null);
    const { selectedItems } = props;
    props.updateTagsForItems(selectedItems.length > 0 ? selectedItems : [itemDetails.id], selectedTags);
    props.onClose();
  };

  const handleTagChange = (tag) => {
    const newTags = { ...selectedTags };
    const newTag = { ...tag };
    const keyName = newTag.key;
    delete newTag['key'];
    newTags[keyName] = newTag;
    setSelectedTags(newTags);
  }

  const handleDeleteTag = (key) => {
    const newTags = { ...selectedTags };
    delete newTags[key];
    setSelectedTags(newTags);
  }

  return (
    <div className="add-item-tags-form">
      <div className="form-header">
        <img src={imgCamelLogo} alt="logo" />
      </div>
      <div className="p-4">
        <h3>Update Tags</h3>
        {props.selectedItems.length > 0 && <p className="items-count">{props.selectedItems.length} items selected</p>}
        <div className="tags-editor-container">
          <p><i>Add existing or create new tags</i></p>
          <div className="add-button">
            <TagsEditor
              className="mr-2 mt-1"
              onChange={handleTagChange}
              selectedTags={{ ...selectedTags }}
              cognitoUser={props.cognitoUser}
              Analytics={props.Analytics}
              contentTags={props.contentTags}
              addContentTagSuccess={props.addContentTagSuccess}
            />
          </div>
          <div className="marks mt-2">
            {
              Object.keys(selectedTags).map(key => 
                <div key={key} className="d-flex justify-content-between">
                  <div>
                    <FontAwesomeIcon key={key} icon={faBookmark} rotation={270} color={selectedTags[key].color} />
                    <span className="ml-1"><i>{key}</i></span>
                  </div>
                  <XCircleIcon className="icons text-white cursor-pointer" onClick={() => handleDeleteTag(key)} />
                </div>
              )
            }
          </div>
        </div>
        <Form.Group as={Row} controlId="actionsContainer" >
          <Col className="d-flex justify-content-end actions-container">
            <Button tabIndex={3} variant="outline-danger" className="mr-2" size="sm" onClick={props.onClose}>CANCEL</Button>
            <Button
              variant="outline-danger"
              size="sm"
              onClick={onSubmit}
              tabIndex={2}
            >
              SAVE
            </Button>
          </Col>
        </Form.Group>
      </div>
    </div>
  )
}

export default UpdateItemTagsForm;
